import { render, staticRenderFns } from "./message.vue?vue&type=template&id=4e57670e&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "../assets/css/login.scss?vue&type=style&index=0&id=4e57670e&prod&lang=scss&scoped=true&external"
import style1 from "../assets/css/message.scss?vue&type=style&index=1&id=4e57670e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57670e",
  null
  
)

export default component.exports